import type {SVGProps} from 'react'
const PaymentMastercardIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    preserveAspectRatio="xMidYMid meet"
    width="1em"
    height="1em"
    overflow="visible"
    style={{
      display: 'block',
    }}
    viewBox="0 0 33 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Group 845081166">
      <path
        id="Vector"
        d="M20.5547 2.13867H11.8047V17.8637H20.5547V2.13867Z"
        fill="var(--fill-0, #FF5F00)"
      />
      <path
        id="Vector_2"
        d="M12.3611 10C12.3611 6.81111 13.8556 3.96944 16.1806 2.13889C14.4806 0.8 12.3333 0 10 0C4.47778 0 0 4.47778 0 10C0 15.5222 4.47778 20 10 20C12.3333 20 14.4778 19.2 16.1806 17.8611C13.8556 16.0306 12.3611 13.1889 12.3611 10Z"
        fill="var(--fill-0, #EB001B)"
      />
      <path
        id="Vector_3"
        d="M32.3612 10C32.3612 15.5222 27.8834 20 22.3612 20C20.0279 20 17.8834 19.2 16.1807 17.8611C18.5057 16.0306 20.0001 13.1889 20.0001 10C20.0001 6.81111 18.5057 3.96944 16.1807 2.13889C17.8807 0.8 20.0279 0 22.3612 0C27.8834 0 32.3612 4.47778 32.3612 10Z"
        fill="var(--fill-0, #F79E1B)"
      />
    </g>
  </svg>
)
export {PaymentMastercardIcon}
